<template>
  <GlPageWrap
    class="relative"
    title="Multi-server Labeling"
  >
<!--    <template #actions>-->
<!--      <GlCoinSelect />-->
<!--    </template>-->

    <div class="flex align-baseline space-between">
      <div class="flex align-end space-between labeling-tabs-wrap mb-4">
        <div class="flex mb-2">
          <h1
              class="tab mr-4 page-title"
              :class="{'tab-active': activeTab === 'config'}"
              @click="handleActiveTab('config')"
          >
            Config
          </h1>
          <h1
              class="tab page-title mr-4"
              :class="{'tab-active': activeTab === 'bulk-labeling'}"
              @click="handleActiveTab('bulk-labeling')"
          >
            Bulk Labeling
          </h1>
        </div>
      </div>
    </div>
    <div
      v-show="activeTab === 'config'"
      class="tagging__block flex fit-content"
    >
      <Config></Config>
    </div>
    <div
        v-show="activeTab === 'bulk-labeling'"
        class="tagging__block flex fit-content"
    >
      <BulkLabeling></BulkLabeling>
    </div>
  </GlPageWrap>
</template>

<script>
// Components
import GlCoinSelect from "@/components/gl-coin-select.vue";
import GlPageWrap from "@/components/layout/gl-page-wrap.vue";
import Config from "@/pages/multi-labeling/components/Config.vue";
import BulkLabeling from "@/pages/multi-labeling/components/BulkLabeling.vue";

export default {
  components: {
    BulkLabeling,
    Config,
    GlPageWrap,
    GlCoinSelect,
  },
  data() {
    return {
      activeTab: 'config',
    }
  },
  methods: {
    handleActiveTab(name) {
      this.activeTab = name
      this.$router.replace({ name: 'multi-labeling', query: { tab: this.activeTab } }).catch(err => err)
    },
  },
}
</script>

<style scoped>
.page-title {
  font-size: 18px;
}

.labeling-tabs-wrap {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab {
  font-weight: 600;
  color: var(--dark-grey-6-e);
  cursor: pointer;
  position: relative;
}

.tab-active {
  font-weight: 600;
  color: var(--space-cadet);
  position: relative;
}

.tab-active::after {
  position: absolute;
  content: "";
  display: block;
  width: 100%;
  height: 4px;
  bottom: -14px;
  background-color: var(--reflex-bluet);
  transition: all 0.5s;
}

.tab-counter {
  height: 20px;
  min-width: 20px;
  border-radius: 20px;
  background: var(--scarlet-red);
  color: #fff;
  position: absolute;
  top: -15px;
  right: -15px;
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1px 4px;
}

.conflicts-marker__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  border-radius: 3px;
  background: var(--pale-pink);
  padding: 10px;
}
</style>
